import dayjs from "dayjs";

export const RestaDeFechasDHM = (fecha1E: string, fecha2E: string) => {
  // Validar y convertir las cadenas de fecha a objetos Day.js
  const fecha1 = dayjs(fecha1E);
  const fecha2 = dayjs(fecha2E);

  if (!fecha1.isValid() || !fecha2.isValid()) {
    return "..."
    // throw new Error('Una o ambas fechas son inválidas.');
  }

  const segundos = fecha2.diff(fecha1, 'second') % 60;
  const dias = fecha2.diff(fecha1, 'day');
  const horas = fecha2.diff(fecha1, 'hour') % 24;
  const minutos = fecha2.diff(fecha1, 'minute') % 60;

  const partes = [];


  if (dias > 0) {
    partes.push(`${dias} día${dias !== 1 ? 's' : ''}`);
  }
  if (horas > 0) {
    partes.push(`${horas} hora${horas !== 1 ? 's' : ''}`);
  }
  if (minutos > 0) {
    partes.push(`${minutos} minuto${minutos !== 1 ? 's' : ''}`);
  }
  if (segundos > 0) {
    partes.push(`${segundos} segundo${segundos !== 1 ? 's' : ''}`);
  }

  return partes.length > 0 ? partes.join(' ') : '0 minutos';
}